
import { useQuery } from "@tanstack/react-query";
import { useClients } from "@/hooks/clients";
import { hasLowSessions } from "@/utils/clientFilters";
import { Client } from "@/models/Client";

export const useUnpaidClients = () => {
  const { data: clients = [], isLoading } = useClients();
  
  return useQuery({
    queryKey: ['unpaidClients', clients.length],
    queryFn: (): Client[] => {
      console.log('Filtering unpaid clients from', clients.length, 'total clients');
      
      // Include clients with unpaid, partial, or pending status
      const unpaidClients = clients.filter(client => 
        client.isActive && 
        (client.paymentStatus === 'unpaid' || 
         client.paymentStatus === 'pending' || 
         client.paymentStatus === 'partial')
      );
      
      console.log('Found', unpaidClients.length, 'clients with payment issues:', {
        unpaid: clients.filter(c => c.isActive && c.paymentStatus === 'unpaid').length,
        partial: clients.filter(c => c.isActive && c.paymentStatus === 'partial').length,
        pending: clients.filter(c => c.isActive && c.paymentStatus === 'pending').length
      });
      
      return unpaidClients;
    },
    enabled: !isLoading,
  });
};

export const useLowSessionsClients = () => {
  const { data: clients = [], isLoading } = useClients();
  
  return useQuery({
    queryKey: ['lowSessionsClients', clients.length],
    queryFn: (): Client[] => {
      console.log('Filtering low sessions clients from', clients.length, 'total clients');
      
      const lowSessionsClients = clients.filter(client => 
        client.isActive && hasLowSessions(client)
      );
      
      console.log('Found', lowSessionsClients.length, 'clients with low sessions');
      return lowSessionsClients;
    },
    enabled: !isLoading,
  });
};
